import request from "@/utils/request";

export default function delMoreTitleById(id) {
    return request({
        url: `/moreTitle/del/`+id,
        method: 'get',
    })
}